import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/user-banner.jpg';

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "banner"
}, null, -1);

const _hoisted_2 = {
  style: {
    "color": "#333333",
    "font-size": "30px",
    "line-height": "40px"
  }
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#666666",
    "font-size": "16px",
    "line-height": "30px"
  }
}, " 挪车码 ", -1);

const _hoisted_4 = {
  style: {
    "color": "#333333",
    "font-size": "30px",
    "line-height": "40px"
  }
};

const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#666666",
    "font-size": "16px",
    "line-height": "30px"
  }
}, "订单", -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_grid_item = _resolveComponent("van-grid-item");

  const _component_van_grid = _resolveComponent("van-grid");

  const _component_van_cell = _resolveComponent("van-cell");

  const _component_van_cell_group = _resolveComponent("van-cell-group");

  return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createVNode(_component_van_grid, {
    clickable: "",
    "column-num": 2
  }, {
    default: _withCtx(() => [_createVNode(_component_van_grid_item, {
      onClick: _ctx.onMyCode
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.data.code_count), 1), _hoisted_3]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_van_grid_item, {
      onClick: _ctx.onMyOrder
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.data.order_count), 1), _hoisted_5]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }), _createVNode(_component_van_cell_group, {
    inset: "",
    style: {
      "margin-top": "20px"
    }
  }, {
    default: _withCtx(() => [_ctx.data.is_auth == 1 ? (_openBlock(), _createBlock(_component_van_cell, {
      key: 0,
      title: "我的钱包",
      "is-link": "",
      onClick: _ctx.onWallet
    }, null, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_van_cell, {
      title: "扫码挪车",
      "is-link": "",
      onClick: _ctx.onScan
    }, null, 8, ["onClick"]), _createVNode(_component_van_cell, {
      title: "常见问题",
      "is-link": "",
      onClick: _ctx.onToQuestion
    }, null, 8, ["onClick"])]),
    _: 1
  })], 64);
}